import script from "./PasswordForgot.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&setup=true&lang=js"

import "./PasswordForgot.vue?vue&type=style&index=0&id=9c3d61cc&scoped=true&lang=css"

import exportComponent from "/Users/damon/workspace/authweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3d61cc"]])

export default __exports__